import theme from '@styles/theme';
export default {
  cartPriceSkeletonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    '> span': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  },
  cartPriceSkeleton: {
    backgroundColor: theme.rawColors.lightGrey300
  }
};